export default "__VITE_ASSET__DOYYhelj__"